import { DtoManoObraGlobal } from "../../../../app/Domain/DtoManoObraGlobal";
import { EntityParams } from "../Domain/EntityParams";
import { RepositoryMain } from "../Domain/RepositoryMain";

export class UseCaseSelectManoObraGlobal {
    private repository: RepositoryMain;

    constructor(_repository: RepositoryMain) {
        this.repository = _repository;
    }

    public async exec(params: EntityParams): Promise<DtoManoObraGlobal[]> {
        return await this._exec(params);
    }

    private async _exec(params: EntityParams): Promise<DtoManoObraGlobal[]> {
        return await this.repository.selectManoObraGlobal(params);
    }
}